module.exports = __webpack_public_path__ + "img/hanxiangmin.0c71b254.jpeg";